import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Api } from '../../services/api';
import { AuthService } from '../../services/auth-service';

@Component({
  selector: 'app-course-details',
  standalone: false,
  templateUrl: './course-details.html',
  styleUrl: './course-details.scss'
})
export class CourseDetails {
   videoMap: {[key: string]: string} = {
    'intro1': 'kpy6QEAuLJw', 
    'intro2': 'abcdefghijk',
    'chatgpt1': 'xyz12345678'
  };
  expandedSections: boolean[] = [false, false, false, false, false];
  showVideoModal = false;
  currentVideo: string | null = null;
  allExpanded = false;
  isLoggedIn: boolean = false;
  constructor(private sanitizer: DomSanitizer,private router: Router,private apiservices:Api,public authService: AuthService) {
    this.authService.isLoggedIn$.subscribe(status => {
      this.isLoggedIn = status;
    });
  }

  toggleSection(index: number): void {
    this.expandedSections[index] = !this.expandedSections[index];
  }

  expandAll(): void {
  this.allExpanded = !this.allExpanded;
  this.expandedSections = this.expandedSections.map(() => this.allExpanded);
}


  closeVideo(): void {
    this.showVideoModal = false;
    this.currentVideo = null;
  }

getSafeVideoUrl(videoKey: string | null): SafeResourceUrl {
    if (!videoKey || !this.videoMap[videoKey]) {
      return this.sanitizer.bypassSecurityTrustResourceUrl('');
    }
    
    const videoId = this.videoMap[videoKey];
    const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?` + 
      `autoplay=1&` +
      `rel=0&` +
      `modestbranding=1&` +
      `enablejsapi=1`;
      
    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

  playVideo(videoKey: string): void {
    this.currentVideo = videoKey;
    this.showVideoModal = true;
  }
  joinMeeting() {
     window.open('https://meet.google.com/eor-oyhw-emi', '_blank');
  }

 onGetStarted() {
  if (this.isLoggedIn) {
    this.router.navigate(['/main-course']).then(success => {
 }).catch(err => {
  console.error('Navigation error:', err);
});
} 
else {
    this.apiservices.displayToast('Please log in to continue.', 500);
  }
}



}
